import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { useAuthStore } from '../store';
import { useOrgStore } from '../store/org';
import { VpState, DemoBanner } from '../components/VelopulseShell';
import useLoad from '../utils/useLoad';
import { vpApi, errorMessage } from '../api/velopulse';
import { ORG_ROLE_LABEL } from '../auth/capabilities';
import '../velopulse.css';

const INVITE_KEY = 'vp_invite_token';

export default function InviteAcceptPage() {
  const { token } = useParams();
  const user = useAuthStore((s) => s.user);
  const { data, error, loading } = useLoad(() => vpApi.previewInvite(token), [token]);
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving] = useState(false);

  const applySession = (payload) => {
    if (payload.token && payload.user) {
      localStorage.setItem('token', payload.token);
      localStorage.setItem('user', JSON.stringify(payload.user));
      axios.defaults.headers.common.Authorization = `Bearer ${payload.token}`;
      useAuthStore.setState({ token: payload.token, user: payload.user });
    }
    sessionStorage.removeItem(INVITE_KEY);
    if (payload.org) {
      useOrgStore.getState().enterOrg(payload.org, '/');
      return;
    }
    window.location.assign('/orgs');
  };

  const handleAccept = async (e) => {
    e.preventDefault();
    if (!data?.existing_user) {
      if (!name.trim()) { toast.error('請輸入姓名'); return; }
      if (password.length < 6) { toast.error('密碼至少 6 個字元'); return; }
      if (password !== confirm) { toast.error('兩次輸入的密碼不一致'); return; }
    }
    const ok = window.confirm(
      data?.existing_user
        ? `確定以現有帳號加入「${data.org_name}」？不會重設你的密碼。`
        : `確定建立帳號並加入「${data.org_name}」？`
    );
    if (!ok) return;
    setSaving(true);
    try {
      const result = await vpApi.acceptInvite(token, data.existing_user ? {} : { name: name.trim(), password });
      toast.success(result.already_member ? '你已是這家公司的成員' : '已加入公司');
      applySession(result);
    } catch (err) {
      toast.error(errorMessage(err, '無法接受邀請'));
      setSaving(false);
    }
  };

  const goLogin = () => {
    sessionStorage.setItem(INVITE_KEY, token);
    window.location.assign('/login');
  };

  return (
    <div className="vp-standalone">
      <DemoBanner />
      <div className="vp-wrap" style={{ maxWidth: 480 }}>
        <h1>接受公司邀請</h1>
        {loading ? <VpState loading /> : error ? (
          <>
            <p className="vp-lead">{errorMessage(error, '邀請連結無效或已過期。')}</p>
            <div className="vp-wrap-actions">
              <Link className="vp-btn" to="/login">前往登入</Link>
            </div>
          </>
        ) : (
          <>
            <p className="vp-lead">
              「{data.org_name}」邀請 {data.email} 以「{data.org_role_label || ORG_ROLE_LABEL[data.org_role]}」加入。
            </p>
            <form className="vp-card" onSubmit={handleAccept}>
              {data.existing_user ? (
                <p className="vp-muted" style={{ marginTop: 0 }}>
                  這個 Email 已有帳號。接受後只會加入這家公司，不會重設密碼。
                  {user && user.email && user.email.toLowerCase() !== data.email
                    ? ' 你目前登入的帳號與此邀請不符，請先登出或改用受邀 Email 登入。'
                    : ''}
                </p>
              ) : (
                <>
                  <label className="vp-label">姓名 *
                    <input className="vp-input" value={name} onChange={(e) => setName(e.target.value)} required />
                  </label>
                  <label className="vp-label">設定密碼 *
                    <input className="vp-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} minLength={6} required />
                  </label>
                  <label className="vp-label">確認密碼 *
                    <input className="vp-input" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} minLength={6} required />
                  </label>
                </>
              )}
              <div className="vp-wiz-actions">
                {data.existing_user && !user ? (
                  <button type="button" className="vp-btn" onClick={goLogin}>先登入</button>
                ) : (
                  <Link className="vp-btn" to="/login">返回登入</Link>
                )}
                <button type="submit" className="vp-btn primary" disabled={saving}>{saving ? '處理中…' : '確認加入'}</button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
